import {
  GET_LABAREA_FAIL,
  GET_LABAREA_SUCCESS,
  GET_LABAREAS_FAIL,
  GET_LABAREAS_SUCCESS,
  ADD_LABAREA_SUCCESS,
  ADD_LABAREA_FAIL,
  UPDATE_LABAREA_SUCCESS,
  UPDATE_LABAREA_FAIL,
  DELETE_LABAREA_SUCCESS,
  DELETE_LABAREA_FAIL,  
  SET_STATE_LABAREA
} from "./actionTypes";

const INIT_STATE = {
  labareas: [],
  labarea: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labAreas = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABAREAS_SUCCESS:
      return {
        ...state,
        labareas: action.payload.labareas,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABAREA:
      return { ...state, loading: action.payload }

    case GET_LABAREAS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABAREA_SUCCESS:
      return {
        ...state,
        labareas: [...state.labareas, action.payload],
      };

    case ADD_LABAREA_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABAREA_SUCCESS:
      return {
        ...state,
        labareas: state.labareas.map(labarea =>
          labarea.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labarea }
            : labarea
        ),
      };

    case UPDATE_LABAREA_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABAREA_SUCCESS:
      return {
        ...state,
        labareas: state.labareas.filter(
          labarea => labarea.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABAREA_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABAREA_SUCCESS:
      return {
        ...state,
        labarea: action.payload,
      };

    case GET_LABAREA_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labAreas;
